import { useContext } from 'react';

import config from '@/config';
import ProfileDataContext from '@/context/ProfileDataContext';
import useCache from '@/hooks/useCache';
import useNavigateToArtwork from '@/hooks/useNavigateToArtwork';
import ProfileContentLoader from '@/shared-components/loader/special-loaders/ProfileContentLoader';
import Text from '@/shared-components/text/components/Text';

import MetaDescripProfilePages from '../MetaDescripProfilePages';

import VirtualList from './components/VirtualList';

import './index.css';

export default function ProfileCollection() {
  const { profileData, internal } = useContext(ProfileDataContext);
  const { loading, fetchData, loadMoreData } = useCache(
    `${profileData._id}_collection`,
    `${config.apis.api.url}/collection/${profileData._id}`,
    {
      injectToken: true,
      includeSearchQueries: { visibility: "private" },
      invalidateWhen: internal
        ? ["BUY_ARTWORK", "EDIT_COLLECTION", `${profileData._id}_REFRESH`]
        : [`${profileData._id}_REFRESH`],
    }
  );

  const navigateToArtwork = useNavigateToArtwork(
    `${profileData._id}_collection`,
    fetchData,
    `/collection/${profileData._id}?`
  );

  // Ensure fetchData is defined and fetchData.data is an array
  const artworks = fetchData && Array.isArray(fetchData.data) ? fetchData.data : [];

  // Filter out private artworks
  const publicArtworks = artworks.filter(
    (artwork) => !artwork.product_metadata.is_private
  );

  return (
    <>
      <MetaDescripProfilePages fetchData={profileData} subPage="collection" />

      {loading ? (
        <div className="profile-collection-loader-container">
          <ProfileContentLoader />
        </div>
      ) : publicArtworks.length === 0 ? (
        <Text className="user-profile__collection-empty-view" paragraph small>
          {internal
            ? "Your collection is currently set to private. Visit 'My Collection' to make your artworks public."
            : "This is a private collection"}
        </Text>
      ) : (
        <VirtualList
          items={{ ...fetchData, data: publicArtworks }}
          onLoadMore={loadMoreData}
          navigateToArtwork={navigateToArtwork}
          profileCollection={true}
        />
      )}
    </>
  );
}
